import moment from 'moment';

export const formatDate = (date: string, formatType = 'DD.MM.YYYY') => {
    return moment(date).utc().format(formatType);
}

export function getFirstDayOfMonth(date: string): Date {
    return new Date(moment(date).startOf('month').format('YYYY-MM-DD'))
}